<div class="w-full h-screen flex items-center justify-center space-y-4 flex-col">
  <i class="fa-solid fa-right-from-bracket text-[80px]"></i>
  <span class="text-center text-lg">Quyền của bạn vừa được cập nhật, vui lòng đăng nhập lại để sử dụng</span>
  <div class="flex items-center space-x-4">
    <button (click)="logout()" nz-button nzType="primary" nzDanger>
      Đăng xuất
    </button>
  </div>
</div>
